import {
    booleanAttribute,
    ComponentRef,
    Directive,
    ElementRef,
    HostListener,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ViewContainerRef
} from '@angular/core';
import {UiBalloonComponent} from '../ui-balloon.component';

@Directive({
    selector: '[ui-balloon-trigger]',
    standalone: false,
})
export class UiBalloonTriggerDirective implements OnChanges, OnDestroy {
    @Input('ui-balloon-trigger') content: string = '';
    @Input({transform: booleanAttribute, alias: "balloon-disabled"}) disabled: boolean = false;
    @Input('balloon-animation') animation: 'waves' | 'bounce' | 'none' = 'bounce';
    @Input('balloon-color') color: 'primary' | 'secondary' | 'warning' | 'danger' | 'info' = 'primary';
    @Input({transform: booleanAttribute, alias: "balloon-show"}) show: boolean = true;
    @Input('balloon-side') side: 'top' | 'left' | 'right' | 'bottom' = 'top';
    @Input('balloon-expandable') expandable: boolean = false;
    @Input('balloon-expanded-content') expandedContent: string = '';
    @Input('balloon-arrow-position') arrowPosition: 'left' | 'center' | 'right' = 'center';
    @Input('balloon-dismissable') dismissable: boolean = false;

    private componentRef: ComponentRef<UiBalloonComponent> | null = null;

    constructor(
        private elementRef: ElementRef,
        private viewContainerRef: ViewContainerRef
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['show'] || changes['disabled'] || changes['content']) {
            this.updateBalloon();
        } else if (this.componentRef) {
            this.setComponentInputs();
        }
    }

    ngOnDestroy(): void {
        this.destroyBalloon();
    }

    private updateBalloon() {
        if (this.shouldShow()) {
            if (!this.componentRef) {
                this.createBalloon();
            } else {
                this.setComponentInputs();
                this.componentRef.instance.show();
            }
        } else {
            this.destroyBalloon();
        }
    }

    private shouldShow(): boolean {
        return !this.disabled && this.show && !!this.content;
    }

    private createBalloon() {
        this.componentRef = this.viewContainerRef.createComponent(UiBalloonComponent);
        document.body.appendChild(this.componentRef.location.nativeElement);
        this.setComponentInputs();
        this.componentRef.instance.setTarget(this.elementRef.nativeElement);
        this.componentRef.instance.show();

        // Handle dismiss event from component if needed
        // this.componentRef.instance.dismissed.subscribe(() => { ... });
    }

    private setComponentInputs() {
        if (this.componentRef) {
            this.componentRef.instance.content = this.content;
            this.componentRef.instance.animation = this.animation;
            this.componentRef.instance.color = this.color;
            this.componentRef.instance.side = this.side;
            this.componentRef.instance.expandable = this.expandable;
            this.componentRef.instance.expandedContent = this.expandedContent;
            this.componentRef.instance.arrowPosition = this.arrowPosition;
            this.componentRef.instance.dismissable = this.dismissable;
        }
    }

    private destroyBalloon() {
        if (this.componentRef) {
            this.componentRef.destroy();
            if (this.componentRef.location.nativeElement.parentNode) {
                this.componentRef.location.nativeElement.parentNode.removeChild(this.componentRef.location.nativeElement);
            }
            this.componentRef = null;
        }
    }
}
